import html from 'html-template-string';
import filter from 'lodash/filter';

const $links = document.querySelectorAll('[data-nav-mobile-link]');

// show any current open nav
filter($links, ($link) => ($link.classList.contains('-current') || $link.classList.contains('-section'))).forEach(($link) => {
    $link.classList.add('-is-open');
});

// deal with clicks
$links.forEach(($link) => {
    const $arrowOpen = html`<img data-nav-arrow class="Nav__arrow -open" src="/_resources/themes/main/images/minus-white.svg" />`;
    const $arrowClosed = html`<img data-nav-arrow class="Nav__arrow -closed" src="/_resources/themes/main/images/plus-white.svg" />`;

    if ($link.classList.contains('-has-children') && $link.classList.contains('-is-open')) {
        $link.appendChild($arrowOpen);
        $link.classList.add('-is-open');
    } else if ($link.classList.contains('-has-children')) {
        $link.appendChild($arrowClosed);
    }

    $link.addEventListener('click', (e) => {
        if (e.target.hasAttribute('data-nav-arrow')) {
            const $icon = $link.querySelector('[data-nav-arrow]');
            e.preventDefault();

            if ($link.classList.contains('-is-open')) {
                $link.classList.remove('-is-open');
                $link.replaceChild($arrowClosed, $icon);
            } else {
                $link.classList.add('-is-open');
                $link.replaceChild($arrowOpen, $icon);
            }
        }
    });
});
